import '../ranking_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.KloutScoreRankingChartView extends Monitoring.Views.Charts.RankingChartView
  twitter_template: JST["backbone/templates/monitoring/charts/twitter_user_ranking"]
  className: 'chart-ranking klout-score-ranking item w1 h3'
  tabs: 1

  render: ->
    ranking = { id:'klout_score_ranking_chart', title:'Klout Score ranking', field: 'users', url:"/monitoring/dashboard/charts/users_by_klout_score/", spanSize: 12 }
    @$el.html(@generic_template({rankings: [ranking],results:@defaultResults}))
    @twitterApi(ranking, @twitter_template)
